// Constants for TarWriter only (reader now uses js-untar library)

/** Tar file type codes (ASCII values) */
export enum TarFileType {
  /** '\0' (ASCII 0) - Regular file */
  File = 0,
  /** '5' (ASCII 53) - Directory */
  Dir = 53,
  /** 'L' (ASCII 76) - GNU tar extension for long filenames */
  GnuLongName = 76
}

/** Maximum filename length in standard tar header (100 bytes) */
export const MAX_FILENAME_LENGTH = 100

/** GNU @LongLink header name for long filename extension */
export const GNU_LONGNAME_HEADER = '././@LongLink'
